
import { Button } from 'reactstrap';
import { Link } from '@s20/components/common/Link';
import { useMountEffect } from '@s20/hooks/state.hooks';


// this needed only in case of using the thank you page,
// which is not the case for the current jotForms implementation
// use case is when the form submission uses POST redirect
const JotFormThankYou = () => {
    useMountEffect(() => {
        if (window.parent) {
            window.parent.postMessage({ thankYou: true }, '*');
        }
    });

    return (
        <div className="p-4 text-center">
            <h1>Thank You!</h1>
            <p>Your submission has been received successfully.</p>
            <p>We appreciate your time.</p>
            <Link
                component={Button}
                to="/"
                className="mt-4"
            >Return to home</Link>
        </div>
    );
};

export default JotFormThankYou;
